<template>
  <div>
    <!-- 到货核查抽查 和 检品操作抽查 -->
    <div class="base">
      <!-- 任务类型 -->
      <div class="taskType">
        <!-- 状态 -->
        <div class="row">
          <div class="label">{{ $t('message.status') }}:</div>
          <div class="val">
            <el-switch v-model="sparkDetail.switch_status" active-text="生效中" inactive-text="不生效">
            </el-switch>
          </div>
        </div>
      </div>
      <!-- 生效时间范围 -->
      <div class="taskType">
        <!-- 生效开始时间   -->
        <div class="row">
          <div class="label">{{ $t('message.effectiveStartTime') }}:</div>
          <div class="val">
            <el-date-picker v-model="sparkDetail.start_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('message.effectiveStartTime')">
            </el-date-picker>
          </div>
        </div>
        <!-- 生效结束时间 -->
        <div class="row">
          <div class="label">{{ $t('message.validityEndTime') }}:</div>
          <div class="val"> <el-date-picker v-model="sparkDetail.end_at" type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('message.validityEndTime')">
            </el-date-picker></div>
        </div>
      </div>
      <!-- 任务群体 -->
      <div class="taskType">

        <div class="row">
          <div class="label">{{ $t('message.taskGroup') }}:</div>
          <div class="val"><el-cascader filterable v-model="sparkDetail.org_id" :options="organizationList" :props="{
            expandTrigger: 'hover',
            label: 'name',
            value: 'id',
            children: 'childs',
            checkStrictly: true,
          }" :placeholder="$t('message.scopeOfPersonnel')" clearable></el-cascader>
          </div>
        </div>
      </div>
      <div class="taskType">
        <!-- 消息推送人 -->
        <div class="row">
          <div class="label">{{ $t('message.messageRecipient') }}:</div>
          <div class="val">
            <el-select v-model="sparkDetail.msg_receive" multiple clearable filterable>
              <el-option v-for="(item, index) in adminList" :key="index" :label="item.realname" :value="item.id + ''">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!-- 生成规则 -->
    <div class="rule" v-if="sparkDetail.id">
      <div class="head">
        <!-- 任务生成规则 -->
        <div class="label">
          {{ $t('message.taskGenerationRule') }}:
        </div>
        <!-- 新增规则 -->
        <el-button type="primary" @click="conditionOption(1)" v-if="isAuth(724)">{{ $t('message.addNewRule')
        }}</el-button>
      </div>
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 订单属性 -->
          <li>{{ $t('message.orderType') }}</li>
          <!-- 生成条件-->
          <li>{{ $t('message.generationCondition') }}</li>
          <!-- 金额 -->
          <li>{{ $t('message.sum') }}</li>
          <!-- 订单属性 -->
          <li>{{ $t('message.theOrderAttribute') }}</li>
          <!-- 生成概率 -->
          <li>{{ $t('message.generationProbability') }}</li>
          <!-- 复购次数 -->
          <li>{{ $t('message.repurchaseCount') }}</li>
          <!-- 服务操作时长 -->
          <li>{{ $t('message.serviceOperationDuration') }}</li>
          <!-- 商品重量尺寸 -->
          <li>{{ $t('message.goodsWeightSize') }}</li>
          <!-- 注意事项 -->
          <li>{{ $t('message.mattersNeedingAttention') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in sparkDetail.record_spark_rule" :key="index">
          <li class="flex05">{{ index + 1 }}</li>
          <!-- 订单属性 -->
          <li>{{ item.condition.order_attribute }}</li>
          <!-- 生成条件 -->
          <li>{{ item.condition.amount_type }}</li>
          <!-- 金额 -->
          <li>金额{{ item.condition.operator }}{{ item.condition.amount_value }}元</li>
          <!-- 订单属性 -->
          <li>{{ setOrderType(item.condition.order_type) }}</li>
          <!-- 生成概率 -->
          <li>{{ item.chance }}%</li>
          <!-- 复购次数 -->
          <li>{{ item.condition.repurchase_count }}</li>
          <!-- 服务操作时长 -->
          <li>{{ item.record_duration ? '需要记录' : '无需记录' }}</li>
          <!-- 商品重量尺寸 -->
          <li>{{ item.record_dimension ? '需要记录' : '无需记录' }}</li>
          <!-- 注意事项 -->
          <li>{{ item.remark }}</li>
          <!-- 操作 -->
          <li>
            <!-- 编辑 -->
            <el-button type="primary" class="primary" @click="conditionOption('', item, index)" v-if="isAuth(725)">
              {{ $t('message.redact') }}
            </el-button>
            <!-- 删除 -->
            <el-button type="primary" @click="recordDeleteRule(item.id, index)" v-if="isAuth(726)">
              {{ $t('message.delete') }}
            </el-button>
          </li>
        </ul>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="btn">
      <!--  : '删除该方式'-->
      <el-button type="primary" class="dark" @click="recordDelete" v-if="isAuth(722)">{{
        $t('message.deleteThisMethod') }}</el-button>
      <!-- 新增 -->
      <el-button type="primary" @click="recordStore" v-if="!sparkDetail.id && isAuth(720)">{{ $t('message.add')
      }}</el-button>
      <!-- 保存修改 -->
      <el-button type="primary" @click="recordUpdate" v-else-if="isAuth(721)">{{ $t('message.saveChanges')
      }}</el-button>
    </div>

    <!-- 规则 -->
    <rule ref="rule" />
  </div>
</template>
<script>

import rule from './rule.vue'
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(["organizationList"]),
    typeList() {
      return this.$store.state.typeList;
    },
  },
  props: {
    options: { type: Array },
    adminList: { type: Array },
    sparkDetail: { type: Object }
  },
  components: {

    rule,
  },
  data() {
    return {
      typeName: '',
    };
  },
  methods: {
    // 具体抽查要求 从系统选择抽查内容
    specificSpotCheckRequirements() {
      this.typeName = this.sparkDetail.type_name
      this.$refs.specificRequirementsSelection.expectList()
    },
    //手动添加
    manuallyAdd() {
      this.$refs.manuallyAddRequirements.dialogVisible = true
      this.$refs.manuallyAddRequirements.content = ''
    },
    //加入任务
    addToTask(list) {
      if (this.sparkDetail.desc == null) this.sparkDetail.desc = []
      list.forEach(item => {
        this.sparkDetail.desc.push(item.desc)
      })
      this.sparkDetail.desc = [...new Set(this.sparkDetail.desc)];
      this.$forceUpdate()
    },
    //规则
    conditionOption(isAdd, item, index) {
      this.ruleIndex = index
      if (isAdd) {
        this.$refs.rule.conditionOption(isAdd, this.type, this.$t('message.addNewRule'))
        this.$refs.rule.datas = {
          record_spark_id: this.sparkDetail.id,
          chance: '',
          remark: '',
          record_duration: 1,
          record_dimension: 1,
          condition: {
            amount_type: '',
            operator: '',
            amount_value: '',
            repurchase_count: '',
            order_attribute: '',
            order_type: 0,
          },
        }
      } else {
        console.log(item);

        this.$refs.rule.conditionOption(isAdd, this.type, this.$t('message.modifyRule'))
        this.$refs.rule.datas = JSON.parse(JSON.stringify(item))
        if (this.$refs.rule.datas.condition.repurchase_count === undefined) {
          this.$refs.rule.datas.condition.repurchase_count = ''
        }
        this.$refs.rule.datas.condition.order_type = this.$refs.rule.datas.condition.order_type - 0
      }
    },
    //自动任务-添加配置
    recordStore() {
      let datas = JSON.parse(JSON.stringify(this.sparkDetail))
      datas.org_id = this.sparkDetail.org_id[this.sparkDetail.org_id.length - 1]
      datas.status = datas.switch_status ? 1 : 0
      this.$api.spotCheckApi.recordStore(datas).then(res => {
        this.$message.success(res.msg)
        this.sparkDetail.id = res.data
      })
    },
    // 自动任务-修改配置
    recordUpdate() {
      let datas = JSON.parse(JSON.stringify(this.sparkDetail))
      datas.status = datas.switch_status ? 1 : 0
      // org_id 是否是数组
      datas.org_id = Array.isArray(this.sparkDetail.org_id) ? this.sparkDetail.org_id[this.sparkDetail.org_id.length - 1] : datas.org_id
      this.$api.spotCheckApi.recordUpdate(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //自动任务-删除规则
    recordDeleteRule(id, index) {
      this.$confirm('是否删除该内容，删除后将无法查询，请确认！', '提示', {
        confirmButtonText: '立即删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.spotCheckApi.recordDeleteRule({ id }).then(res => {
          this.sparkDetail.record_spark_rule.splice(index, 1)
          this.$message.success(res.msg)
        })

      }).catch(() => {
      });
    },
    //自动任务-删除配置
    recordDelete() {
      this.$confirm('是否删除该配置，删除后将无法查询，请确认！', '提示', {
        confirmButtonText: '立即删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.spotCheckApi.recordDelete({ id: this.sparkDetail.id }).then(res => {
          this.$message.success(res.msg)
          setTimeout(() => {
            window.open("about:blank", "_top").close();
          }, 1000)
        })
      }).catch(() => {
      });
    },
    // 显示订单属性名称
    setOrderType(type) {
      return this.typeList.find(item => item.key == type - 0).value
    },
  }
}
</script>
<style lang='scss' scoped>
.base {
  display: flex;
  padding-bottom: 42px;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 42px;

  .taskType {
    width: 320px;
    margin-right: 60px;

    .row {
      display: flex;
      margin-bottom: 30px;
      line-height: 40px;

      /deep/.is-disabled {
        .el-input__inner {
          background-color: #fff;
          color: #606266;
        }

      }

      &:nth-last-child(1) {
        margin: 0;
      }

      .label {
        width: 100px;
      }

      .val {
        flex: 1;
      }
    }
  }

  .specificSpotCheckRequirements {
    margin: 0 60px;

    .table {
      width: 772px;
      margin-top: 24px;
      margin-left: 88px;

      ol {
        height: 50px;
      }

      ul {
        background-color: #fff;
        padding: 20px 0;
      }

      .flex3 {
        flex: 3;
      }

      .flex2 {
        flex: 2;
      }
    }
  }

  .executor {
    display: flex;

    .label {
      width: 100px;

    }

    .value {
      flex: 1;

      .row {
        margin-bottom: 22px;
      }
    }
  }
}

.rule {
  .head {
    display: flex;
    justify-content: space-between;

    .label {
      font-size: 20px;
      font-weight: 600;
      line-height: 40px;
    }
  }

  .table {
    margin: 20px 0;

    ol {
      height: 50px;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
    }

    .flex05 {
      flex: 0.5;
    }
  }
}

.btn {
  margin: 42px 0 0;
}
</style>
